import {BaseContainerModel} from '../../base-container.model';
import {
  bl_aat_claim_document_line_attachment_RowClass,
} from '../../../dbschema';

export class MyClaimDocumentLineAttachmentModel extends BaseContainerModel {
  bl_aat_claim_document_line_attachment: bl_aat_claim_document_line_attachment_RowClass = new bl_aat_claim_document_line_attachment_RowClass();
}
